import { getYearMonthDay } from '@nx-smartmonkey/shared/helpers';
import moment from 'moment';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import * as routing from '../../../../constants/Routing';
import { useRetrieveActiveProject } from '../../../../hooks/project/useRetrieveActiveProject';
import { useRouterQuery } from '../../../../hooks/useRouterQuery';
import { PlanActionType } from '../context/actions';
import { usePlanContext } from '../context/context';

const SELECTED_DAY_PARAM = `selected_day`;

interface UseSetSelectedDayResponse {
  selectedDay?: Date;
  setSelectedDay: (date: Date) => void;
}

export const useSetSelectedDay = (): UseSetSelectedDayResponse => {
  const navigate = useNavigate();
  const location = useLocation();
  const { planState, planDispatch } = usePlanContext();
  const { data: activeProject } = useRetrieveActiveProject();
  const urlParams = useRouterQuery();

  useEffect(() => {
    // Only adds the selectedDay in the url if we are already in one of the planner plans pages.
    if (location.pathname.includes(routing.PLANNER.PLANS.replace(`:projectId`, activeProject!.id))) {
      const selectedDayParam = urlParams.get(SELECTED_DAY_PARAM);
      if (!selectedDayParam) {
        setSelectedDay(moment().utc().toDate());
        return;
      } else {
        const selectedDay = moment(selectedDayParam, `YYYY-MM-DD`);

        if (selectedDay.isValid()) {
          setSelectedDay(selectedDay.utc().toDate());
        } else {
          setSelectedDay(moment().utc().toDate());
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setSelectedDay = (date: Date) => {
    planDispatch({
      type: PlanActionType.SET_SELECTED_DAY,
      payload: {
        selectedDay: date,
      },
    });

    const dateString = getYearMonthDay({ date });
    navigate(`${routing.PLANNER.PLANS.replace(`:projectId`, activeProject!.id)}?${SELECTED_DAY_PARAM}=${dateString}`);
  };

  return {
    selectedDay: planState.selectedDay,
    setSelectedDay,
  };
};
